"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var StyledFormControl = (0, _styles.styled)(_material.FormControl)({
  background: 'transparent'
});
var _default = StyledFormControl;
exports.default = _default;